export default __webpack_public_path__ + "static/media/8940.bfabb5e0.svg";